module.exports = __webpack_public_path__ + "static/media/activity-contract.2fb4aca5.svg";